import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 400 400"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  style: {"fill":"none"},
  d: "M0 0h400v400H0z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M153.62 301.59c94.34 0 145.94-78.16 145.94-145.94 0-2.22 0-4.43-.15-6.63A104.356 104.356 0 0 0 325 122.47a102.39 102.39 0 0 1-29.46 8.07 51.471 51.471 0 0 0 22.55-28.37 102.783 102.783 0 0 1-32.57 12.45 51.34 51.34 0 0 0-87.41 46.78A145.623 145.623 0 0 1 92.4 107.81a51.33 51.33 0 0 0 15.88 68.47A50.912 50.912 0 0 1 85 169.86v.65a51.311 51.311 0 0 0 41.15 50.28 51.222 51.222 0 0 1-23.16.88 51.35 51.35 0 0 0 47.92 35.62 102.924 102.924 0 0 1-63.7 22 104.461 104.461 0 0 1-12.21-.74 145.208 145.208 0 0 0 78.62 23",
  style: {"fill":"#1da1f2"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }